import { required, maxLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    name: { required, maxLength: maxLength(30) },
  },
}

export const validateComputed = {
  nameErrors() {
    const errors = []
    if (!this.$v.form.name.$dirty) return errors
    !this.$v.form.name.maxLength && errors.push('Descrição não pode ter mais de 30 dígitos')
    !this.$v.form.name.required && errors.push('Descrição é obrigatório.')
    return errors
  },
}
